import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ChatMessage, RepoOverviewState, ReposSettings, ReposSettingsPatch } from './repos.models';

export const ReposActions = createActionGroup({
  source: 'Repos',
  events: {
    Load: emptyProps(),
    // `projectId` is an optional override used by async refresh flows to keep
    // writing to the project that was active when the operation started, even if
    // the user switches projects mid-flight. When absent, the active project is used.
    'Set Chat Messages': props<{ messages: ChatMessage[]; projectId?: string }>(),
    'Save Settings': props<{ settings: ReposSettings; projectId?: string }>(),
    'Patch Settings': props<{ patch: ReposSettingsPatch; projectId?: string }>(),
    'Save State': props<{ state: RepoOverviewState; projectId?: string }>(),
    'Patch State': props<{ patch: Partial<RepoOverviewState>; projectId?: string }>(),
  },
});
